<div [ngClass]="{
  'tab-pane fade': true,
  'show active': isCurrentTab === tabs.Package,
  'package-content': openedFrom != openedFromType.MatAccount && openedFrom != openedFromType.RequestToChangePackage && openedFrom != openedFromType.RequestToChangeAdmin && openedFrom !=openedFromType.SwapPackageForAdmin
  && openedFrom != openedFromType.SwapPackage
  }" id="package-tab-pane" role="tabpanel" aria-labelledby="package-tab" tabindex="0">
  <div
    *ngIf="!packages.length && !showForm && openedFrom == openedFromType.Package && userRole.includes(roles.SuperAdmin)"
    class="create-block px-2">
    <img class="" src="../assets/images/package-plus.png" alt="" />
    <h3 class="my-4 pt-2 content-center">No package has been created yet.</h3>
    <button type="button" class="btn theme-btn px-4" data-bs-toggle="modal" data-bs-target="#exampleModal"
      (click)="showCreateForm()">
      Create Package</button>
  </div>
  <div *ngIf="showForm">
    <div
      [ngClass]="userRole.length && !userRole.includes(roles.MatAdmin) ? 'content-box create-package-contentbox pb-0' : 'content-box admin-content-box'"
      [formGroup]="packageForm">
      <div class="row">
        <ng-container *ngIf="openedFrom != openedFromType.RequestToChangePackage; else forRequestToChangePackage">
          <div class="col-sm-6 mb-4">
            <div class="">
              <span class="black-text fs-14 mb-1">Package Name </span>
              <input type="text" [required]="true" formControlName="packageName" class="form-control"
                [class.is-invalid]="packageForm.controls['packageName'].invalid && packageForm.controls['packageName'].touched" />
            </div>
            <div
              *ngIf="(packageForm.controls['packageName'].invalid && packageForm.controls['packageName'].touched) || packageForm.controls['packageName'].dirty">
              <small *ngIf="packageForm.controls['packageName'].errors?.['required']" class="text-danger fs-13">Package
                Name is required</small>
            </div>
          </div>
          <div class="col-sm-6 mb-4">
            <div class="">
              <div class="d-flex">
                <span class="black-text fs-14 mb-1">Number of License</span>
                <mat-icon matTooltipPosition="left" matTooltip="Maximum number of subscriptions for this package"
                  class="fs-22 ms-2">info</mat-icon>
              </div>
              <input type="number" [required]="true" formControlName="totalRoleCount" min=1 class="form-control"
                step="1" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                [class.is-invalid]="packageForm.controls['totalRoleCount'].invalid && packageForm.controls['totalRoleCount'].touched" />
            </div>
            <div
              *ngIf="(packageForm.controls['totalRoleCount'].invalid && packageForm.controls['totalRoleCount'].touched) || packageForm.controls['totalRoleCount'].dirty">
              <small *ngIf="packageForm.controls['totalRoleCount'].errors?.['required']" class="text-danger fs-13">No of
                License is required</small>
            </div>
          </div>
        </ng-container>
        <ng-template #forRequestToChangePackage>
          <div class="col-sm-6 mb-2">
            <div class="">
              <span class="black-text fs-14 mb-1"> Existing Package </span>
              <input type="text" [required]="true" formControlName="existingPackageName" class="form-control" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="mb-2 mat-account-selectoption">
              <mat-label class="black-text fs-14 mb-1">New Package</mat-label>
              <mat-form-field class="mt-1">
                <mat-select [required]="true" formControlName="newPackageName"
                  (selectionChange)="this.editPackage($event.value, openedFromType.RequestToChangePackage)"
                  [class.is-invalid]="
                    packageForm.controls['newPackageName'].invalid &&
                    packageForm.controls['newPackageName'].touched">
                  @for (package of packages; track package) {
                  <mat-option [value]="package" [style.font-weight]="package.packageId == -1 ? 'bold' : 'normal'">{{
                    package.packageName }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <div *ngIf="
                  (packageForm.controls['newPackageName'].invalid &&
                  packageForm.controls['newPackageName'].touched) ||
                  packageForm.controls['newPackageName'].dirty">
                <small *ngIf="packageForm.controls['newPackageName'].errors?.['required']" class="text-danger fs-13">New
                  Package is required</small>
              </div>
            </div>
          </div>
          <div class="row">
            <span class="text-blacka fs-18 font-bold mb-1">{{ packageForm.controls['newPackageName'].value ? (
              packageForm.controls['newPackageName'].value?.packageId == -1 ? 'New Package Details' :
              packageForm.controls['newPackageName'].value.packageName) : packageToEdit.packageName }} Details</span>
            <div class="col-sm-12" *ngIf="packageForm.controls['newPackageName'].value?.packageId != -1">
              <div class="mb-2">
                <span class="black-text fs-14 mb-1">Features</span>
                <mat-form-field>
                  <mat-select #select formControlName="existingFeatures" multiple
                    [class.is-invalid]="packageForm.controls['existingFeatures'].invalid && packageForm.controls['existingFeatures'].touched"
                    (valueChange)="this.selectedGroupedFeatures= generateSelectedFeatures($event)"
                    >
                    <mat-select-trigger>
                      <span class="chip-list-head">Added Items:</span>
                      <span class="chip-main">
                        <div *ngFor="let featureGroupValue of selectedGroupedFeatures | keyvalue">
                          <h4 class="black-text fs-14 mb-1" style="font-weight: bolder; margin-top: 1em;">{{featureGroupValue.key}}
                          </h4>
                          <span style="display: inline-block;margin-left: 0.25em;font-size: 0.8em;"
                            *ngFor="let featureValue of featureGroupValue.value" class="chip-list toolkit-display"
                            title="{{featureValue.featureName}}">
                            <label class="toolkit-display">
                              <span class="toolkit-display-name">{{featureValue.featureName}}</span>
                            </label>
                            <a class="close">
                              <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                                  stroke-linejoin="round" />
                              </svg>
                            </a>
                          </span>
                        </div>
                      </span>
                      @if ((packageForm.controls['existingFeatures'].value?.length || 0) > 0) {
                      <span class="chip-list count"
                        (click)="$event.stopPropagation();$event.preventDefault();previewPopup('Added Feature', packageControl.Feature, undefined)">
                        #{{(packageForm.controls['existingFeatures'].value?.length || 0) }}
                      </span>
                      }
                    </mat-select-trigger>
                    @for (feature of features; track feature) {
                    <mat-option [disabled]="true" [value]="feature">{{feature.featureName}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="mb-2">
                <span class="black-text fs-14 mb-1">Module</span>
                <mat-form-field>
                  <mat-select #select required formControlName="existingModules" multiple
                    (selectionChange)="onModuleChange($event)"
                    [class.is-invalid]="packageForm.controls['existingModules'].invalid && packageForm.controls['existingModules'].touched">
                    <mat-select-trigger>
                      <span class="chip-list-head">Added Items:</span>
                      <span class="chip-main">
                        <span *ngFor="let moduleValue of packageForm.controls['existingModules'].value"
                          class="chip-list">{{moduleValue.moduleName}}
                          <a class="close">
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                              <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            </svg>
                          </a>
                        </span>
                      </span>
                      @if ((packageForm.controls['existingModules'].value?.length || 0) > 0) {
                      <span class="chip-list count"
                        (click)="$event.stopPropagation();$event.preventDefault();previewPopup('Added Modules', packageControl.Module, undefined)">
                        #{{(packageForm.controls['existingModules'].value?.length || 0) }}
                      </span>
                      }
                    </mat-select-trigger>
                    @for (module of modules; track module) {
                    <mat-option [disabled]="true" [value]="module">{{module.moduleName}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              <div
                [ngClass]="userRole.includes(roles.SchoolAdmin) || userRole.includes(roles.MatAdmin) ? 'schooladmin-sub-category mb-2' : 'mb-2'">
                <span class="black-text fs-14 mb-1">Analytics Toolkit</span>
                <mat-form-field>
                  <mat-select required formControlName="existingSubCategories" multiple
                    [class.is-invalid]="packageForm.controls['existingSubCategories'].invalid && packageForm.controls['existingSubCategories'].touched"
                    class="px-2">
                    <mat-select-trigger>
                      <span class="chip-list-head">Added Items:</span>
                      <span class="chip-main">
                        <div *ngFor="let rg of selectedGroupedSubcategories | keyvalue">
                          <h4 class="black-text fs-14 mb-1" style="font-weight: bolder; margin-top: 1em;">{{rg.key}}
                          </h4>
                          <span style="display: inline-block;margin-left: 0.25em;font-size: 0.8em;"
                            *ngFor="let subCategoryValue of rg.value" class="chip-list toolkit-display"
                            title="{{subCategoryValue.subCategoryName}}">
                            <label class="toolkit-display">
                              <mat-icon style="font-size: 1.8em;"
                                *ngIf="subCategoryValue.subCategoryDisplayName!=null">short_text</mat-icon>
                              <span class="toolkit-display-text"
                                *ngIf="subCategoryValue.subCategoryDisplayName!=null">{{subCategoryValue.subCategoryDisplayName}}</span>
                              <span class="toolkit-display-name">{{subCategoryValue.subCategoryName}}</span>
                            </label>
                            <a class="close">
                              <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                                  stroke-linejoin="round" />
                              </svg>
                            </a>
                          </span>
                        </div>

                      </span>
                      @if ((packageForm.controls['existingSubCategories'].value?.length || 0) > 0) {
                      <span class="chip-list count"
                        (click)="$event.stopPropagation();$event.preventDefault();previewPopup('Added Analytics Toolkits', packageControl.SubCategory, undefined)">
                        #{{(packageForm.controls['existingSubCategories'].value?.length)}}
                      </span>
                      }
                    </mat-select-trigger>
                    <mat-optgroup *ngFor="let rg of this.groupedExistingSubcategories | keyvalue"
                      [label]="rg.key">
                      @for (subCategory of rg.value; track subCategory) {
                      <mat-option [class.multiline]="subCategory.subCategoryDisplayName!=null" [disabled]="true"
                        [value]="subCategory">
                        @if(subCategory.subCategoryDisplayName==null)
                        {
                        {{subCategory.subCategoryName}}
                        }
                        @else {
                        <label class="toolkit-display">
                          <mat-icon>short_text</mat-icon>
                          <span class="toolkit-display-text">{{subCategory.subCategoryDisplayName}}</span>
                          <span class="toolkit-display-name">{{subCategory.subCategoryName}}</span>
                        </label>
                        }

                      </mat-option>
                      }
                    </mat-optgroup>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div *ngIf="!showNewPackageDetails" class="col-sm-12 text-end">
            <div class="mt-0 mt-sm-0 pt-0 pt-sm-0">
              <button (click)="showNewPackageDetails = true" [disabled]="!packageForm.controls['newPackageName'].value"
                type="button" class="btn theme-btn-outline">
                Add New Module
              </button>
            </div>
          </div>
        </ng-template>
      </div>
      <div *ngIf="showNewPackageDetails || openedFrom != openedFromType.RequestToChangePackage">
        <h3 *ngIf="openedFrom != openedFromType.RequestToChangePackage && openedFrom != openedFromType.Notification"
          class="mb-2">{{ isEdit ? "Update" : "Create" }}</h3>
        <h3
          *ngIf="openedFrom == openedFromType.RequestToChangePackage && packageForm.controls['newPackageName'].value?.packageId != -1 ">
          {{ "Add New Module & Analytics Toolkit" }}</h3>
          <!-- FEATURES -->
        <div class="row">
          <div class="col-md-12">
            <div *ngIf="openedFrom == openedFromType.RequestToChangePackage"
              class="dropdown dropdown-actions view-list-dropdown" style="float: right;">
              <button (click)="featureSelect.open()"
                class="dropdown-toggle existing-package-btn btn theme-btn-underline w-100" type="button"
                data-bs-toggle="dropdown" aria-expanded="false">
                View Feature List
              </button>
            </div>
            <div class="mb-2">
              <span class="black-text fs-14 mb-1">Add-On Features (optional)</span>
              <mat-form-field>
                <mat-select #featureSelect formControlName="features" multiple 
                (valueChange)="this.selectedGroupedFeatures = generateSelectedFeatures($event)"
                  [class.is-invalid]="packageForm.controls['features'].invalid && packageForm.controls['features'].touched">
                  <mat-select-trigger>
                    <span class="chip-list-head">Added Items:</span>
                    <span class="chip-main">
                       <div *ngFor="let rg of selectedGroupedFeatures | keyvalue">
                        <h4 class="black-text fs-14 mb-1" style="font-weight: bolder; margin-top: 1em;">{{rg.key}}</h4>
                        <span style="display: inline-block;margin-left: 0.25em;font-size: 0.8em;"
                          *ngFor="let featureValue of rg.value" class="chip-list toolkit-display"
                          title="{{featureValue.featureName}}">
                          <label class="toolkit-display">
                            <span class="toolkit-display-name">{{featureValue.featureName}}</span>
                          </label>
                          <a *ngIf="openedFrom != openedFromType.Notification" class="close"
                            (click)="$event.stopPropagation();$event.preventDefault();removeFeature(featureValue);">
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                              <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            </svg>
                          </a>
                        </span>
                      </div>
                    </span>
                    @if ((packageForm.controls['features'].value?.length || 0) > 0) {
                    <span class="chip-list count"
                      (click)="$event.stopPropagation();$event.preventDefault();previewPopup('Added features', packageControl.Feature, undefined)">
                      #{{(packageForm.controls['features'].value?.length)}}
                    </span>
                    }
                  </mat-select-trigger>

                  <mat-optgroup *ngFor="let rg of this.groupedFeatures | keyvalue" [label]="rg.key">
                    @for (feature of rg.value; track feature) {
                    <mat-option multiline
                      [disabled]="(packageForm.controls['newPackageName'].value?.packageId != -1 && packageForm.controls['existingFeatures'].value?.includes(feature)) || openedFrom == openedFromType.Notification"
                      [value]="feature">
                      
                      {{feature.featureName}}
                      

                    </mat-option>
                    }
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <!--MODULES-->
        <div class="row">
          <div class="col-sm-12">
            <div *ngIf="openedFrom == openedFromType.RequestToChangePackage"
              class="dropdown dropdown-actions view-list-dropdown" style="float: right;">
              <button (click)="moduleSelect.open()"
                class="dropdown-toggle existing-package-btn btn theme-btn-underline w-100" type="button"
                data-bs-toggle="dropdown" aria-expanded="false">
                View Module List
              </button>
            </div>
            <div class="mb-2">
              <span class="black-text fs-14 mb-1">Module</span>
              <mat-form-field>
                <mat-select #moduleSelect required formControlName="modules" multiple
                  (selectionChange)="onModuleChange($event)"
                  [class.is-invalid]="packageForm.controls['modules'].invalid && packageForm.controls['modules'].touched">
                  <mat-select-trigger>
                    <span class="chip-list-head">Added Items:</span>
                    <span class="chip-main">
                      <span *ngFor="let moduleValue of packageForm.controls['modules'].value"
                        class="chip-list">{{moduleValue.moduleName}}
                        <a *ngIf="openedFrom != openedFromType.Notification" class="close"
                          (click)="$event.stopPropagation();$event.preventDefault();removeModule(moduleValue)">
                          <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                              stroke-linejoin="round" />
                            <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                              stroke-linejoin="round" />
                          </svg>
                        </a>
                      </span>
                    </span>
                    @if ((packageForm.controls['modules'].value?.length || 0) > 0) {
                    <span class="chip-list count"
                      (click)="$event.stopPropagation();$event.preventDefault();previewPopup('Added Modules', packageControl.Module, undefined)">
                      #{{(packageForm.controls['modules'].value?.length)}}
                    </span>
                    }
                  </mat-select-trigger>
                  @for (module of modules; track module) {
                  <mat-option
                    [disabled]="(packageForm.controls['newPackageName'].value?.packageId != -1 && packageForm.controls['existingModules'].value?.includes(module)) || openedFrom == openedFromType.Notification"
                    [value]="module">{{module.moduleName}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="(packageForm.controls['modules'].invalid && packageForm.controls['modules'].touched) || packageForm.controls['modules'].dirty">
                <small *ngIf="packageForm.controls['modules'].errors?.['required']" class="text-danger fs-13">Module is
                  required</small>
              </div>
            </div>
            <div *ngIf="openedFrom == openedFromType.RequestToChangePackage"
              class="dropdown dropdown-actions view-list-dropdown" style="float: right;">
              <button (click)="subcategorySelect.open()"
                class="dropdown-toggle existing-package-btn btn theme-btn-underline w-100" type="button"
                data-bs-toggle="dropdown" aria-expanded="false">
                View Analytics Toolkit List
              </button>
            </div>

            <!-- TOOLKITS -->
            <div class="mb-2">
              <span class="black-text fs-14 mb-1">Analytics Toolkit</span>
              <mat-form-field>
                <mat-select #subcategorySelect required formControlName="subCategories"
                  (valueChange)="this.selectedGroupedSubcategories = generateSelectedCategoryModules($event)" multiple
                  [class.is-invalid]="packageForm.controls['subCategories'].invalid && packageForm.controls['subCategories'].touched">
                  <mat-select-trigger>
                    <span class="chip-list-head">Added Items:</span>
                    <span class="chip-main">
                      <div *ngFor="let rg of selectedGroupedSubcategories | keyvalue">
                        <h4 class="black-text fs-14 mb-1" style="font-weight: bolder; margin-top: 1em;">{{rg.key}}</h4>
                        <span style="display: inline-block;margin-left: 0.25em;font-size: 0.8em;"
                          *ngFor="let subCategoryValue of rg.value" class="chip-list toolkit-display"
                          title="{{subCategoryValue.subCategoryName}}">
                          <label class="toolkit-display">
                            <mat-icon style="font-size: 1.8em;"
                              *ngIf="subCategoryValue.subCategoryDisplayName!=null">short_text</mat-icon>
                            <span class="toolkit-display-text"
                              *ngIf="subCategoryValue.subCategoryDisplayName!=null">{{subCategoryValue.subCategoryDisplayName}}</span>
                            <span class="toolkit-display-name">{{subCategoryValue.subCategoryName}}</span>
                          </label>
                          <a *ngIf="openedFrom != openedFromType.Notification" class="close"
                            (click)="$event.stopPropagation();$event.preventDefault();removeSubCategory(subCategoryValue);">
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                              <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            </svg>
                          </a>
                        </span>
                      </div>
                    </span>
                    @if ((packageForm.controls['subCategories'].value?.length || 0) > 0) {
                    <span class="chip-list count"
                      (click)="$event.stopPropagation();$event.preventDefault();previewPopup('Added Analytics Toolkits', packageControl.SubCategory, undefined)">
                      #{{(packageForm.controls['subCategories'].value?.length)}}
                    </span>
                    }
                  </mat-select-trigger>
                  <mat-optgroup *ngFor="let rg of this.groupedSubCategories | keyvalue" [label]="rg.key">
                    @for (subCategory of rg.value; track subCategory) {
                    <mat-option [class.multiline]="subCategory.subCategoryDisplayName!=null"
                      [disabled]="(packageForm.controls['newPackageName'].value?.packageId != -1 && packageForm.controls['existingSubCategories'].value?.includes(subCategory)) || openedFrom == openedFromType.Notification"
                      [value]="subCategory">
                      @if(subCategory.subCategoryDisplayName==null)
                      {
                      {{subCategory.subCategoryName}}
                      }
                      @else {
                      <label class="toolkit-display">
                        <mat-icon>short_text</mat-icon>
                        <span class="toolkit-display-text">{{subCategory.subCategoryDisplayName}}</span>
                        <span class="toolkit-display-name">{{subCategory.subCategoryName}}</span>
                      </label>
                      }

                    </mat-option>
                    }
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="(packageForm.controls['subCategories'].invalid && packageForm.controls['subCategories'].touched) || packageForm.controls['subCategories'].dirty">
                <small *ngIf="packageForm.controls['subCategories'].errors?.['required']"
                  class="text-danger fs-13">Analytics Toolkit is required</small>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="sticky-btns">
      <div class="row">
        <div class="col-sm-12 text-right">
          <button type="button" class="btn theme-btn-outline create-package" (click)="closeCreateForm()">Cancel</button>
          <button
            *ngIf="openedFrom != openedFromType.RequestToChangePackage && openedFrom != openedFromType.Notification"
            type="button" class="btn theme-btn cancel-package ms-3" [disabled]="packageForm.invalid"
            (click)="createPackage()">{{ isEdit ? "Update" : "Create" }}</button>
          <button *ngIf="openedFrom == openedFromType.RequestToChangePackage" type="button"
            class="btn theme-btn cancel-package ms-3" [disabled]="packageForm.controls['newPackageName'].invalid"
            (click)="requestToChangePackage()">Send Request</button>
          <button *ngIf="openedFrom == openedFromType.Notification" type="button"
            class="btn theme-btn cancel-package ms-3" [disabled]="packageForm.invalid" (click)="createPackage()">Create
            & Assign</button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="openedFrom == openedFromType.SwapPackageForAdmin">
    <div class="sticky-btns">
      <div class="row">
        <div class="col-sm-12 text-right">
          <button type="button" class="btn theme-btn-outline create-package"
            (click)="undoChangePackage()">Cancel</button>
          <button type="button" class="btn theme-btn cancel-package ms-3" [disabled]="newlySelectedRow == 0"
            (click)="updatePackage()">Update</button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="packages.length && !showForm" [ngClass]="
   {
    'swap-package-table': openedFrom === openedFromType.SwapPackage,
    'mat-swap-package-table': openedFrom === openedFromType.MatAccount,
    'change-package-table': openedFrom === openedFromType.SwapPackageForAdmin
  }" class="px-0">
    <table class="table table-hover" aria-describedby="This table describes the package information">
      <thead>
        <tr class="swap-header">
          <th class="ps-5"><span class="ps-2">Package Name</span></th>
          <th>Number of Modules</th>
          <th>Number of Analytics Toolkits</th>
          <th>Number of Metrics</th>
          <th>Number of License</th>
          <th class="action-header">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngIf="(openedFrom == openedFromType.RequestToChangePackage || openedFrom == openedFromType.RequestToChangeAdmin) && selectedElement"
          class="px-2 selected">
          <td class="fs-18 px-2 d-flex">
            <ng-container>
              <div class="d-flex">
                <span class="initial-circle my-0"><span>{{selectedElement.packageName.charAt(0)}}</span></span>
                <p matTooltip="{{selectedElement.packageName}}" class="mat-account-detail my-auto">
                  {{selectedElement.packageName}}</p>
              </div>
            </ng-container>
          </td>
          <td class="fs-18">
            <p class="mat-account-detail user-detail-empid my-auto">
              {{selectedElement.modules.length}}</p>
          </td>
          <td class="fs-18">
            <p class="mat-account-detail user-detail-empid my-auto">{{selectedElement.subCategories.length}}</p>
          </td>
          <td class="fs-18">
            <p class="mat-account-detail user-detail-empid my-auto">{{selectedElement.metrics.length}}</p>
          </td>
          <td class="fs-18">
            <p class="mat-account-detail user-detail-empid my-auto">{{selectedElement.totalRoleCount}}</p>
          </td>
          <td class="fs-18 text-left">
            <a class="dropdown-item" class="btn-action mr-0"
              (click)="$event.preventDefault();$event.stopPropagation();previewPopup('', packageControl.Package, selectedElement)"
              matTooltipPosition="left" matTooltip="Edit details">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.9833 9.99993C12.9833 11.6499 11.6499 12.9833 9.99993 12.9833C8.34993 12.9833 7.0166 11.6499 7.0166 9.99993C7.0166 8.34993 8.34993 7.0166 9.99993 7.0166C11.6499 7.0166 12.9833 8.34993 12.9833 9.99993Z"
                  stroke="#5D847B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M10.0001 16.8918C12.9418 16.8918 15.6834 15.1584 17.5918 12.1584C18.3418 10.9834 18.3418 9.00843 17.5918 7.83343C15.6834 4.83343 12.9418 3.1001 10.0001 3.1001C7.05845 3.1001 4.31678 4.83343 2.40845 7.83343C1.65845 9.00843 1.65845 10.9834 2.40845 12.1584C4.31678 15.1584 7.05845 16.8918 10.0001 16.8918Z"
                  stroke="#5D847B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </a>
          </td>
        </tr>
        <h3 class="fs-21 font-bold color-black-pearl p-4"
          *ngIf="openedFrom == openedFromType.RequestToChangePackage || openedFrom == openedFromType.RequestToChangeAdmin">
          Other Package</h3>
        <ng-container *ngFor="let package of filter(packages)">
          <tr
            (click)="(openedFrom == openedFromType.MatAccount || openedFrom == openedFromType.SwapPackage || openedFrom == openedFromType.SwapPackageForAdmin) ? onRowClick(package.packageId): ''"
            [ngClass]="{'selected': (selectedRow === package.packageId && (openedFrom != openedFromType.SwapPackageForAdmin && openedFrom != openedFromType.RequestToChangeAdmin)) || (newlySelectedRow == package.packageId && openedFrom == openedFromType.SwapPackageForAdmin) }"
            class="select-package-row">
            <td class="fs-18">
              <ng-container *ngIf="openedFrom != openedFromType.SwapPackage; else forOthers">
                <div class="d-flex">
                  <span class="initial-circle my-0">
                    <span>{{package.packageName.charAt(0)}}</span></span>
                  <p matTooltip="{{package.packageName}}" class="mat-account-detail my-auto"> {{package.packageName}}
                  </p>
                </div>
                <p class="mb-0 ml55 text-left color-blue fs-12"
                  *ngIf="selectedPackage === package.packageId && (openedFrom == openedFromType.RequestToChangeAdmin || openedFrom == openedFromType.SwapPackageForAdmin)">
                  Already Selected</p>
              </ng-container>
              <ng-template #forOthers>
                <div class="d-flex">
                  <mat-radio-button [checked]="selectedElement === package"
                    (click)="packageAssigned.emit(package.packageId)"></mat-radio-button>
                  <p matTooltip="{{package.packageName}}" class="mat-account-detail my-auto">{{package.packageName}}</p>
                </div>
              </ng-template>
            </td>
            <td class="fs-18">{{package.modules.length}}</td>
            <td class="fs-18">{{package.subCategories.length}}</td>
            <td class="fs-18">{{package.metrics.length}}</td>
            <td class="fs-18">{{package.totalRoleCount}}</td>
            <td>
              <ng-container *ngIf="openedFrom == openedFromType.Package; else openedForOthers">
                <div class="d-flex align-items-start">
                  <div class="form-check form-switch package-switch me-1">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="package.status" role="switch"
                      id="flexSwitchCheckDefault" (click)="activateDeactivatePackage(package)">
                    <label class="form-check-label fs-12 mt-1" [ngClass]="!package.status ? 'text-muted' : 'theme-text'"
                      for="flexSwitchCheckDefault">{{ package.status ? "Active" : "Inactive" }}</label>
                  </div>
                  <div class="dropdown dropdown-actions">
                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                      aria-expanded="false">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                          stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                          stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                          stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
                    <ul class="dropdown-menu">
                      <li><a class="dropdown-item" (click)="previewPopup('', packageControl.Package, package)"
                          matTooltipPosition="left" matTooltip="View details"><svg width="20" height="20"
                            viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M12.9833 9.99993C12.9833 11.6499 11.6499 12.9833 9.99993 12.9833C8.34993 12.9833 7.0166 11.6499 7.0166 9.99993C7.0166 8.34993 8.34993 7.0166 9.99993 7.0166C11.6499 7.0166 12.9833 8.34993 12.9833 9.99993Z"
                              stroke="#5D847B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M10.0001 16.8918C12.9418 16.8918 15.6834 15.1584 17.5918 12.1584C18.3418 10.9834 18.3418 9.00843 17.5918 7.83343C15.6834 4.83343 12.9418 3.1001 10.0001 3.1001C7.05845 3.1001 4.31678 4.83343 2.40845 7.83343C1.65845 9.00843 1.65845 10.9834 2.40845 12.1584C4.31678 15.1584 7.05845 16.8918 10.0001 16.8918Z"
                              stroke="#5D847B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>View</a></li>
                      <li><a class="dropdown-item" (click)="editPackage(package)" matTooltipPosition="left"
                          matTooltip="Edit details"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M11.05 3.00002L4.20829 10.2417C3.94996 10.5167 3.69996 11.0584 3.64996 11.4334L3.34162 14.1333C3.23329 15.1083 3.93329 15.775 4.89996 15.6084L7.58329 15.15C7.95829 15.0834 8.48329 14.8084 8.74162 14.525L15.5833 7.28335C16.7666 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2333 1.75002 11.05 3.00002Z"
                              stroke="#5D847B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                              stroke-linejoin="round" />
                            <path d="M9.90845 4.20825C10.2668 6.50825 12.1334 8.26658 14.4501 8.49992" stroke="#5D847B"
                              stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                              stroke-linejoin="round" />
                            <path d="M2.5 18.3333H17.5" stroke="#5D847B" stroke-width="1.5" stroke-miterlimit="10"
                              stroke-linecap="round" stroke-linejoin="round" />
                          </svg>Edit</a></li>
                      <li><a class="dropdown-item" (click)="deletePackage(package)" matTooltipPosition="left"
                          matTooltip="Delete details"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M10.4999 1.5C10.9141 1.5 11.2499 1.16421 11.2499 0.75C11.2499 0.335787 10.9141 0 10.4999 0H5.49992C5.0857 0 4.74992 0.335786 4.74992 0.75C4.74992 1.16421 5.0857 1.5 5.49992 1.5L10.4999 1.5ZM1.33325 3.58333H1.44226L2.13845 13.0111L2.13849 13.0117C2.23268 14.2735 3.28338 15.25 4.54891 15.25H11.4489C12.7167 15.25 13.7689 14.2699 13.8595 13.0053L13.8595 13.0051L14.5323 3.58333H14.6666C15.0808 3.58333 15.4166 3.24755 15.4166 2.83333C15.4166 2.41912 15.0808 2.08333 14.6666 2.08333H13.8351L13.8339 2.08333H2.13891L2.13826 2.08333H1.33325C0.919038 2.08333 0.583252 2.41912 0.583252 2.83333C0.583252 3.24755 0.919038 3.58333 1.33325 3.58333ZM3.63433 12.9L2.94634 3.58333H13.0285L12.3633 12.8981C12.3289 13.3784 11.9294 13.75 11.4489 13.75H4.54891C4.06954 13.75 3.6703 13.38 3.63435 12.9003L3.63433 12.9ZM10.4166 7C10.4166 6.58579 10.0808 6.25 9.66658 6.25C9.25237 6.25 8.91658 6.58579 8.91658 7V10.3333C8.91658 10.7475 9.25237 11.0833 9.66658 11.0833C10.0808 11.0833 10.4166 10.7475 10.4166 10.3333V7ZM6.74992 6.25C7.16413 6.25 7.49992 6.58579 7.49992 7V10.3333C7.49992 10.7475 7.16413 11.0833 6.74992 11.0833C6.3357 11.0833 5.99992 10.7475 5.99992 10.3333V7C5.99992 6.58579 6.3357 6.25 6.74992 6.25Z"
                              fill="#F24822" />
                          </svg>Delete</a></li>
                    </ul>
                  </div>
                </div>
              </ng-container>
              <ng-template #openedForOthers>
                <a class="dropdown-item" class="btn-action" matTooltipPosition="left" matTooltip="View details"
                  (click)="$event.preventDefault();$event.stopPropagation();previewPopup('', packageControl.Package, package)">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12.9833 9.99993C12.9833 11.6499 11.6499 12.9833 9.99993 12.9833C8.34993 12.9833 7.0166 11.6499 7.0166 9.99993C7.0166 8.34993 8.34993 7.0166 9.99993 7.0166C11.6499 7.0166 12.9833 8.34993 12.9833 9.99993Z"
                      stroke="#5D847B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M10.0001 16.8918C12.9418 16.8918 15.6834 15.1584 17.5918 12.1584C18.3418 10.9834 18.3418 9.00843 17.5918 7.83343C15.6834 4.83343 12.9418 3.1001 10.0001 3.1001C7.05845 3.1001 4.31678 4.83343 2.40845 7.83343C1.65845 9.00843 1.65845 10.9834 2.40845 12.1584C4.31678 15.1584 7.05845 16.8918 10.0001 16.8918Z"
                      stroke="#5D847B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
                <a *ngIf="openedFrom != openedFromType.RequestToChangePackage" class="btn-action"
                  matTooltipPosition="left" matTooltip="Edit details"
                  (click)="$event.preventDefault();$event.stopPropagation();editPackage(package)">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M11.05 3.00002L4.20829 10.2417C3.94996 10.5167 3.69996 11.0584 3.64996 11.4334L3.34162 14.1333C3.23329 15.1083 3.93329 15.775 4.89996 15.6084L7.58329 15.15C7.95829 15.0834 8.48329 14.8084 8.74162 14.525L15.5833 7.28335C16.7666 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2333 1.75002 11.05 3.00002Z"
                      stroke="#5D847B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M9.90845 4.20825C10.2668 6.50825 12.1334 8.26658 14.4501 8.49992" stroke="#5D847B"
                      stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M2.5 18.3333H17.5" stroke="#5D847B" stroke-width="1.5" stroke-miterlimit="10"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
              </ng-template>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>